module.exports = __webpack_public_path__ + "img/assess-price.a8880189.svg";